const STEPS = ['ولي الأمر', 'الطفل', 'نوع الدخول', 'الكارت والدفع'];

export function Stepper({ step }) {
  return (
    <div className="card flex items-center gap-2 px-[18px] py-3.5 mb-4">
      {STEPS.map((label, i) => {
        const idx = i + 1;
        const done = step > idx;
        const active = step === idx;
        return (
          <div key={label} className="flex items-center gap-2 flex-1 last:flex-none">
            <div className="flex items-center gap-2" style={{ opacity: done || active ? 1 : 0.55 }}>
              <div
                className="w-7 h-7 rounded-full grid place-items-center font-bold text-xs"
                style={{
                  background: done ? '#22C55E' : active ? '#FF7A1A' : '#F4EFE6',
                  color: done || active ? '#fff' : '#9CA3AF'
                }}
              >
                {done ? '✓' : idx}
              </div>
              <span className={`text-[13px] ${active ? 'font-bold' : 'font-medium'}`}>{label}</span>
            </div>
            {i < STEPS.length - 1 ? (
              <div
                className="flex-1 h-0.5 rounded-sm"
                style={{ background: done ? '#22C55E' : '#EFE7D6' }}
              />
            ) : null}
          </div>
        );
      })}
    </div>
  );
}
